import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=365a5af9&"
import script from "./Editable.vue?vue&type=script&lang=js&"
export * from "./Editable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Editable.vue?vue&type=custom&index=0&blockType=div&contenteditable=true&%40input=%24emit('update%3Acontent'%2C%20%24event.target.innerText)"
if (typeof block0 === 'function') block0(component)

export default component.exports